import { Progress, Button, Space } from 'antd';
import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';

const Resume = () => {
  return (
  <>
  <Space>
    Click on to download my resume , Thanks !   
   <a href={process.env.PUBLIC_URL + "/asset/resume/KrishnaDevOps.pdf"} ><Button type="primary" icon={<DownloadOutlined />}/></a> 
   </Space>
  </>
  )
};

export default Resume;